common.View.create('search::MobileButton', {

    onDOMLoad() {
        this.initSlideout();
    },

    initSlideout() {
        // Find trigger slideout element
        this.element.find('.triggerSlideout')
            .on('click', (event) => {
                let $slideOutMenu = $('body').find('.search\\:\\:MobileBar .slideOutMenu');

                // Slide out the menu
                $slideOutMenu.toggleClass('-translate-y-full');

                // Focus on input instantly
                if( !$slideOutMenu.hasClass('-translate-y-full') ) {
                    $slideOutMenu.find('input').focus();
                } else {
                    $slideOutMenu.find('input').removeFocus();
                }
            });
    },

});
